export default __webpack_public_path__ + "static/media/fiercely-independent-img4.747a66ba.jpg";